import React, { useState } from "react";
import { BusinessDetailsType, GstSignatoryDetails } from ".";
import {
  isPanValid,
  isTanValid,
  preventEnterKey,
  returnInputFieldLength,
} from "../../../../utils/commonFunctions";
import { TrashIcon, UploadNew } from "../../../Icon";
import {
  PanVerifyType,
  TanVerifyType,
} from "../../../../redux/services/serviceTypes";
import { BusinessAddressListType } from "../../../../redux/clientSettings/clientSettingTypes";
import {
  DisableiIcon,
  EnableiIcon,
  RedCheckIcon,
  VerifyIcon,
  WhiteCheckIcon,
} from "../../../../assets/images";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import GstSignatoryDeatils from "./GstSignatoryDeatils";

type AppProps = {
  businessDetails: BusinessDetailsType | any;
  success: number | null;
  panError?: string;
  legalNameError?: string;
  tradeNameError?: string;
  gstError?: string | null;
  handleBusinessDetailsChange: (e: any) => void;
  handleToggleUploadLogoModal: (e: any) => void;
  handleDeleteUploadedLogo: () => void;
  companyLogo: any;
  getGstDetails: (e: any) => void;
  authorizedGetPanDetails: (e: any) => void;
  getPanDetails: (e: any) => void;
  getTanDetails: (e: any) => void;
  getBankDetails: (e: any) => void;
  panVerifyDetails: PanVerifyType | null;
  authorizedPanVerifyDetails: PanVerifyType | null;
  tanVerifyDetails: TanVerifyType | null;
  businessAddressData: BusinessAddressListType | undefined;
  handleGstChange: (e: any) => void;
  gstSignatoryDeatils: GstSignatoryDetails
};

const BusinessDetails = ({
  businessDetails,
  panError,
  tradeNameError,
  legalNameError,
  handleBusinessDetailsChange,
  handleToggleUploadLogoModal,
  handleDeleteUploadedLogo,
  companyLogo,
  getGstDetails,
  getPanDetails,
  getTanDetails,
  getBankDetails,
  panVerifyDetails,
  tanVerifyDetails,
  businessAddressData,
  success,
  handleGstChange,
  gstSignatoryDeatils,
  authorizedPanVerifyDetails,
  authorizedGetPanDetails
}: AppProps) => {
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;
  const [isHovered, setIsHovered] = useState(false);


  const handleDownload = async (fileUrl: string, fileName: string) => {
    const response = await fetch(`${blobBaseUrl}${fileUrl}?${blobToken}`);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName || "downloaded_file";
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);

  };

  const {
    invoiceHeading,
    gst,
    pan,
    msmeRegistrationNo,
    tan,
    cin,
    legalName,
    tradeName,
    notes,
    registrationType,
    registrationDate,
    constitutionOfBusiness,
    companyStatus,
    tin,
    gstUsername,
  } = businessDetails;
  return (
    <>
      {/* First Row */}
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div className="position-relative">
                <label htmlFor="PAN" className={pan ? "active" : ""}>
                  PAN Number*
                </label>
                <input
                  type="text"
                  onKeyDown={preventEnterKey}
                  className={`form-control ${!!panError ? "error-border" : null
                    }`}
                  name="pan"
                  value={pan}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={10}
                />
                <span
                  className="position-absolute"
                  style={{ top: "30px", right: "5px" }}
                >
                  {(panVerifyDetails?.status === "VALID" &&
                    pan?.length === 10) ||
                    (businessAddressData &&
                      businessAddressData?.pan_details?.status === "VALID" &&
                      businessAddressData?.pan_number === pan &&
                      pan?.length === 10) ? (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        <Tooltip id="button-view-filter-invoice">
                          <div>
                            <div className="text-left">
                              Full Name :{" "}
                              {panVerifyDetails?.full_name
                                ? panVerifyDetails?.full_name
                                : businessAddressData?.pan_details?.full_name
                                  ? businessAddressData?.pan_details?.full_name
                                  : "NA"}
                            </div>
                            <div className="text-left">
                              PAN No :{" "}
                              {panVerifyDetails?.pan
                                ? panVerifyDetails?.pan
                                : businessAddressData?.pan_details?.pan
                                  ? businessAddressData?.pan_details?.pan
                                  : "NA"}
                            </div>
                            <div className="text-left">
                              Category :{" "}
                              {panVerifyDetails?.category
                                ? panVerifyDetails?.category
                                : businessAddressData?.pan_details?.category
                                  ? businessAddressData?.pan_details?.category
                                  : "NA"}
                            </div>
                            <div className="text-left">
                              Status :{" "}
                              {panVerifyDetails?.status
                                ? panVerifyDetails?.status
                                : businessAddressData?.pan_details?.status
                                  ? businessAddressData?.pan_details?.status
                                  : "NA"}
                            </div>
                          </div>
                        </Tooltip>
                      }
                    >
                      <img src={EnableiIcon} alt="enable" />
                    </OverlayTrigger>
                  ) : (
                    <img src={DisableiIcon} alt="disable" />
                  )}
                </span>
                {!!panError && (
                  <small className="text-danger">{panError}</small>
                )}
              </div>
              {(panVerifyDetails?.status === "VALID" && pan?.length === 10) ||
                (businessAddressData &&
                  businessAddressData?.pan_details?.status === "VALID" &&
                  businessAddressData?.pan_number === pan &&
                  pan?.length === 10) ? (
                <span>
                  <img src={VerifyIcon} alt="pan" />{" "}
                  <span style={{ color: "#28a745" }}>PAN is Verified</span>
                </span>
              ) : panVerifyDetails?.status === "INVALID" ? (
                <span className="text-danger">PAN is Invalid</span>
              ) : (
                <span className="input-length">
                  {returnInputFieldLength(pan?.length, 10)}
                </span>
              )}
            </div>
          </form>
        </div>
        <div className="col-md-2 mt-4">
          <div className="form-group mt-3">
            <button
              className="btn btn-outline"
              disabled={
                (pan && pan?.length > 9 ? false : true) ||
                (businessDetails?.pan?.length &&
                  !isPanValid(businessDetails?.pan?.length ? pan?.trim() : ""))
              }
              onClick={(e) => {
                getPanDetails(e);
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <img
                src={isHovered ? WhiteCheckIcon : RedCheckIcon}
                alt="check"
              />{" "}
              <span>Verify</span>
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label
                  htmlFor="msmeRegistrationNo"
                  className={msmeRegistrationNo ? "active" : ""}
                >
                  MSME Registration Number
                </label>
                <input
                  type="text"
                  onKeyDown={preventEnterKey}
                  className={`form-control`}
                  name="msmeRegistrationNo"
                  value={msmeRegistrationNo}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="row">
        <span
          className="ml-3 mt-2"
          style={{ color: "#bfcbe1", marginBottom: "-10px" }}
        >
          Click button below to get GST details in form
        </span>
      </div>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="GST" className={gst ? "active" : ""}>
                  GST Username
                </label>
                <input
                  type="text"
                  onKeyDown={preventEnterKey}
                  className={`form-control`}
                  name="gstUsername"
                  value={gstUsername}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="GST" className={gst ? "active" : ""}>
                  GST Number
                </label>
                <input
                  type="text"
                  onKeyDown={preventEnterKey}
                  className={`form-control`}
                  name="gst"
                  value={gst}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={15}
                />
              </div>
              <span className="input-length">
                {returnInputFieldLength(gst?.length, 15)}
              </span>
              {success == 0 && !!(gst?.length ? gst?.length > 14 : false) && (
                <p style={{ color: "#e7733e", fontSize: "10px" }}>
                  Invalid GST Number. Please try again.
                </p>
              )}
            </div>
          </form>
        </div>
        <div className="col-md-3 mt-4">
          <div className="form-group mt-3">
            <button
              className="btn btn-outline"
              disabled={gst && gst?.length > 14 ? false : true}
              onClick={(e) => {
                getGstDetails(e);
              }}
            >
              Verify and Get
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label
                  htmlFor="Legal Name"
                // className={`active`}
                >
                  Legal Name*
                </label>
                <input
                  type="text"
                  onKeyDown={preventEnterKey}
                  className={`form-control ${!!legalNameError ? "error-border" : null
                    }`}
                  name="legalName"
                  value={legalName}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                />
                {!!legalNameError && (
                  <small className="text-danger">{legalNameError}</small>
                )}
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label
                  htmlFor="Trade Name"
                  className={tradeName ? "active" : ""}
                >
                  Trade Name*
                </label>
                <input
                  type="text"
                  onKeyDown={preventEnterKey}
                  className={`form-control ${!!tradeNameError ? "error-border" : null
                    }`}
                  name="tradeName"
                  value={tradeName}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                />
                {!!tradeNameError && (
                  <small className="text-danger">{tradeNameError}</small>
                )}
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label
                  htmlFor="Registration Type"
                // className={pan ? "active" : ""}
                >
                  Registration Type
                </label>
                <input
                  type="text"
                  onKeyDown={preventEnterKey}
                  className={`form-control`}
                  name="registrationType"
                  value={registrationType}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={10}
                  disabled
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label
                  htmlFor="Registration Date"
                // className={pan ? "active" : ""}
                >
                  Registration Date
                </label>
                <input
                  type="text"
                  onKeyDown={preventEnterKey}
                  className={`form-control`}
                  name="registrationDate"
                  value={registrationDate}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={10}
                  disabled
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label
                  htmlFor="Constitution of Business"
                // className={pan ? "active" : ""}
                >
                  Constitution of Business
                </label>
                <input
                  type="text"
                  onKeyDown={preventEnterKey}
                  className={`form-control`}
                  name="constitutionOfBusiness"
                  value={constitutionOfBusiness}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={10}
                  disabled
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label
                  htmlFor="Company Status"
                // className={pan ? "active" : ""}
                >
                  Company Status
                </label>
                <input
                  type="text"
                  onKeyDown={preventEnterKey}
                  className={`form-control`}
                  name="companyStatus"
                  value={companyStatus}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={10}
                  disabled
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="CIN" className={cin ? "active" : ""}>
                  CIN Number
                </label>
                <input
                  type="text"
                  onKeyDown={preventEnterKey}
                  className={`form-control`}
                  name="cin"
                  value={cin}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={21}
                />
              </div>
              <span className="input-length">
                {returnInputFieldLength(cin?.length, 21)}
              </span>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="TIN" className={tin ? "active" : ""}>
                  TIN(VAT) Number
                </label>
                <input
                  type="number"
                  // onKeyDown={preventEnterKey}
                  className={`form-control`}
                  name="tin"
                  value={tin}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={11}
                  onWheel={(event) => event.currentTarget.blur()}
                />
              </div>
              <span className="input-length">
                {returnInputFieldLength(tin?.length, 11)}
              </span>
            </div>
          </form>
        </div>
      </div>

      {/* ////gst details */}
      <GstSignatoryDeatils
        handleGstChange={handleGstChange}
        gstSignatoryDeatils={gstSignatoryDeatils}
        authorizedPanVerifyDetails={authorizedPanVerifyDetails}
        businessAddressData={businessAddressData}
        getPanDetails={authorizedGetPanDetails}

      />

      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group">
              <div className="position-relative">
                <label htmlFor="TAN">TAN Number</label>
                <input
                  type="text"
                  onKeyDown={preventEnterKey}
                  className={`form-control`}
                  name="tan"
                  value={tan}
                  onChange={(e) => handleBusinessDetailsChange(e)}
                  maxLength={10}
                />
                <span
                  className="position-absolute"
                  style={{ top: "30px", right: "5px" }}
                >
                  {(tanVerifyDetails?.nameOrgn?.length && tan?.length === 10) ||
                    (businessAddressData &&
                      businessAddressData?.tan_details?.nameOrgn?.length &&
                      businessAddressData?.tan_number === tan &&
                      tan?.length === 10) ? (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        <Tooltip id="button-view-filter-invoice">
                          <div>
                            <div className="text-left">
                              <span>Full Name :</span>{" "}
                              <span className="branch">
                                {tanVerifyDetails?.nameOrgn
                                  ? tanVerifyDetails?.nameOrgn
                                  : businessAddressData?.tan_details?.nameOrgn
                                    ? businessAddressData?.tan_details?.nameOrgn
                                    : null}
                              </span>
                            </div>
                            <div className="text-left">
                              <span>Address Line 1 :</span>{" "}
                              <span className="micr">
                                {tanVerifyDetails?.addLine1
                                  ? tanVerifyDetails?.addLine1
                                  : businessAddressData?.tan_details?.addLine1
                                    ? businessAddressData?.tan_details?.addLine1
                                    : null}
                              </span>
                            </div>
                            <div className="text-left">
                              <span>Address Line 2 :</span>{" "}
                              <span className="micr">
                                {tanVerifyDetails?.addLine2
                                  ? tanVerifyDetails?.addLine2
                                  : businessAddressData?.tan_details?.addLine2
                                    ? businessAddressData?.tan_details?.addLine2
                                    : null}
                              </span>
                            </div>
                            <div className="text-left">
                              <span>Address Line 3 :</span>{" "}
                              <span className="micr">
                                {tanVerifyDetails?.addLine3
                                  ? tanVerifyDetails?.addLine3
                                  : businessAddressData?.tan_details?.addLine3
                                    ? businessAddressData?.tan_details?.addLine3
                                    : null}
                              </span>
                            </div>
                            <div className="text-left">
                              <span>Address Line 5 :</span>{" "}
                              <span className="micr">
                                {tanVerifyDetails?.addLine5
                                  ? tanVerifyDetails?.addLine5
                                  : businessAddressData?.tan_details?.addLine5
                                    ? businessAddressData?.tan_details?.addLine5
                                    : null}
                              </span>
                            </div>
                            <div className="text-left">
                              <span>PIN :</span>{" "}
                              <span className="micr">
                                {tanVerifyDetails?.pin
                                  ? tanVerifyDetails?.pin
                                  : businessAddressData?.tan_details?.pin
                                    ? businessAddressData?.tan_details?.pin
                                    : null}
                              </span>
                            </div>
                            <div className="text-left">
                              <span>Phone Number :</span>{" "}
                              <span className="micr">
                                {tanVerifyDetails?.phoneNum
                                  ? tanVerifyDetails?.phoneNum
                                  : businessAddressData?.tan_details?.phoneNum
                                    ? businessAddressData?.tan_details?.phoneNum
                                    : null}
                              </span>
                            </div>
                            <div className="text-left">
                              <span>Email :</span>{" "}
                              <span className="micr">
                                {tanVerifyDetails?.emailId1
                                  ? tanVerifyDetails?.emailId1
                                  : businessAddressData?.tan_details?.emailId1
                                    ? businessAddressData?.tan_details?.emailId1
                                    : null}
                              </span>
                            </div>
                          </div>
                        </Tooltip>
                      }
                    >
                      <img src={EnableiIcon} alt="enable" />
                    </OverlayTrigger>
                  ) : (
                    <img src={DisableiIcon} alt="disable" />
                  )}
                </span>
              </div>

              {(tanVerifyDetails?.nameOrgn?.length && tan?.length === 10) ||
                (businessAddressData &&
                  businessAddressData?.tan_details?.nameOrgn?.length &&
                  businessAddressData?.tan_number === tan &&
                  tan?.length === 10) ? (
                <span>
                  <img src={VerifyIcon} alt="tan" />{" "}
                  <span style={{ color: "#28a745" }}>TAN is Verified</span>
                </span>
              ) : tanVerifyDetails?.messages[0]?.desc === "No record found" ? (
                <span className="text-danger">No record found</span>
              ) : (
                <span className="input-length">
                  {returnInputFieldLength(tan?.length, 10)}
                </span>
              )}
            </div>
          </form>
        </div>
        <div className="col-md-2 mt-4">
          <div className="form-group">
            <button
              className="btn btn-outline"
              disabled={
                (tan && tan?.length > 9 ? false : true) ||
                (businessDetails?.tan?.length &&
                  !isTanValid(businessDetails?.tan?.length ? tan?.trim() : ""))
              }
              onClick={(e) => {
                getTanDetails(e);
              }}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <img
                src={isHovered ? WhiteCheckIcon : RedCheckIcon}
                alt="check"
              />{" "}
              <span>Verify</span>
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <label htmlFor="invoiceHeading">Invoice Heading</label>
              <input
                type="text"
                onKeyDown={preventEnterKey}
                className={`form-control`}
                name="invoiceHeading"
                value={invoiceHeading}
                onChange={(e) => handleBusinessDetailsChange(e)}
              />
            </div>
          </form>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4">
          <form>
            <div className="form-group mt-3 d-flex flex-column">
              <label htmlFor="companyLogo">
                Upload Company Logo (PNG/JPG up to 2MB)
              </label>
              {Object.keys(companyLogo).length ? (
                <div className="pointer d-flex flex-row mt-2">
                  {/* eslint-disable-next-line */}
                  <a

                    onClick={() =>
                      handleDownload(companyLogo?.file_url, companyLogo?.file_name)
                    }
                    target="_blank"
                    className="uploaded_file_name"
                  >
                    {companyLogo?.file_name}
                  </a>
                  <div className="ml-2" onClick={handleDeleteUploadedLogo}>
                    <TrashIcon />
                  </div>
                </div>
              ) : (
                <button
                  className="btn btn-sm btn-outline mt-2 w-50"
                  onClick={(e: any) => handleToggleUploadLogoModal(e)}
                >
                  <span>
                    <UploadNew /> Upload Logo
                  </span>
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <form>
            <div className="form-group mt-3">
              <label htmlFor="invoiceHeading">
                Notes (To be shown in downloaded invoices)
              </label>
              <textarea
                className={`form-control`}
                name="notes"
                value={notes}
                onChange={(e) => handleBusinessDetailsChange(e)}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default BusinessDetails;
